export function useSizeable(props) {
  let sizeableString = null;
  if (props.xxSmall || props.size === "2xs") {
    sizeableString = "2xs";
  } else if (props.xSmall || props.size === "xs") {
    sizeableString = "xs";
  } else if (props.small || props.size === "sm") {
    sizeableString = "sm";
  } else if (props.medium || props.size === "md") {
    sizeableString = "md";
  } else if (props.large || props.size === "lg") {
    sizeableString = "lg";
  } else if (props.xLarge || props.size === "xl") {
    sizeableString = "xl";
  } else if (props.xxLarge || props.size === "2xl") {
    sizeableString = "2xl";
  }
  return {
    sizeableString
  };
}
